/**
 * ConsoleAdapter.ts - ConsoleAdapter
 * 
 * CHANGE HISTORY:
 * - 251021_0517 [8786ca9] danielbeer: feat: apply authr pattern to all 43 remaining packages
 * - 251021_0447 [ce7b5e6] danielbeer: feat: automate TypeScript and Actr integration for all packages
 * - 251021_0421 [7529d5e] danielbeer: feat: migrate all packages to TypeScript structure
 */
import { LogLevel } from '../models/LogEntry';

export class ConsoleAdapter {
    options: Record<string, unknown>;
  colors: any;

  constructor(options = {}) {
    this.options = {
      minLevel: options.minLevel !== undefined ? options.minLevel : LogLevel.INFO,
      colors: options.colors !== false,
      timestamps: options.timestamps !== false,
      ...options
    };
    
    this.colors = {
      TRACE: '\x1b[90m',    // Gray
      DEBUG: '\x1b[36m',    // Cyan
      INFO: '\x1b[32m',     // Green
      WARN: '\x1b[33m',     // Yellow
      ERROR: '\x1b[31m',    // Red
      FATAL: '\x1b[35m',    // Magenta
      RESET: '\x1b[0m'
    };
  }
  
  /**
   * Write log entry
   */
  write(logEntry): any {
    if (!logEntry.isLevelEnabled(this.options.minLevel)) {
      return;
    }
    
    const message = this.format(logEntry);
    
    // Use appropriate console method
    switch (logEntry.level) {
      case LogLevel.TRACE:
      case LogLevel.DEBUG:
        console.debug(message);
        break;
      case LogLevel.INFO:
        console.info(message);
        break;
      case LogLevel.WARN:
        console.warn(message);
        break;
      case LogLevel.ERROR:
      case LogLevel.FATAL:
        console.error(message);
        if (logEntry.error) {
          console.error(logEntry.error);
        }
        break;
      default:
        console.log(message);
    }
  }
  
  /**
   * Format log entry
   */
  format(logEntry): any {
    let message = '';
    
    if (this.options.colors && typeof process !== 'undefined') {
      const color = this.colors[logEntry.levelName] || this.colors.RESET;
      message = `${color}${logEntry.toConsoleString()}${this.colors.RESET}`;
    } else {
      message = logEntry.toConsoleString();
    }
    
    return message;
  }
}

export default ConsoleAdapter;
